/* eslint-disable @typescript-eslint/no-explicit-any */
import {FC} from 'react'
import {ErrorMessage, useFormikContext } from 'formik'
import { MyEditor } from '../../../apps/components/MyEditor';
import SimpleLoader from '../../../apps/components/SimpleLoader';

type Props = {
  values:any,
  submitLoader: boolean;
  disableFormFields: boolean;
}

const ProjectStatus: FC<Props> = ({values,submitLoader,disableFormFields}) => {
  const { setFieldValue } = useFormikContext();
  return (
    <div className='w-100 position-relative'>
      {submitLoader && <SimpleLoader />}
      <div className='mb-10 fv-row mt-5'>
        <MyEditor disabled={disableFormFields} value={values.project_status} setValue={(value:string)=>{
          setFieldValue("project_status", value);
        }} /> 
        <div className='text-danger mt-2'>
          <ErrorMessage name='project_status' />
        </div>      
      </div>

    </div>
  )
}

export {ProjectStatus}
